import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import * as SDK from '@replai-platform/sdk';
import * as provider from '../../api/provider';

const getPerformancesvReport = async (
  requestParams: SDK.GetPerformanceCsvReportRequest
): Promise<SDK.GetPerformanceCsvReportResponse> => {
  const res = await provider.getJson<object, SDK.GetPerformanceCsvReportResponse>(
    `${SDK.BASE_URL()}/performance/metrics_csv?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

const KEY = 'performance-csv-report';
type Key = typeof KEY;

type Result = SDK.GetPerformanceCsvReportResponse;
type QueryKey = [Key, SDK.GetPerformanceCsvReportRequest];

type QueryOptions<R = Result> = UseQueryOptions<Result, unknown, R, QueryKey>;
type QueryResult<R = Result> = UseQueryResult<R>;

const queryFn: QueryFunction<Result, QueryKey> = ({ queryKey: [, requestParams] }) =>
  getPerformancesvReport(requestParams);

// This is exported so we can use useQueries
export function getPerformanceCsvReportQueryOptions<R = Result>(
  requestParams: SDK.GetPerformanceCsvReportRequest,
  options?: QueryOptions<R>
): QueryOptions<R> {
  return {
    queryKey: [KEY, requestParams],
    queryFn,
    ...options,
  };
}

export default function usePerformanceCsvReport<R = Result>(
  requestParams: SDK.GetPerformanceCsvReportRequest,
  options?: QueryOptions<R>
): QueryResult<R> {
  return useQuery(getPerformanceCsvReportQueryOptions(requestParams, options));
}
